import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLeadPersonalEmailSequences as GetLeadPersonalEmailSequencesQuery,
    GetLeadPersonalEmailSequences_lead_stages as LeadStages,
    GetLeadPersonalEmailSequencesVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_PERSONAL_EMAIL_SEQUENCES from '../queries/get-lead-personal-email-sequences.graphql';

export const useGetLeadPersonalEmailSequences = (
    leadId: string
): {
    stages: LeadStages | null | undefined;
    isLoading: boolean;
    isFirstLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {data, error, refetch, networkStatus, loading} = useQuery<
        GetLeadPersonalEmailSequencesQuery,
        GetLeadPersonalEmailSequencesVariables
    >(GET_LEAD_PERSONAL_EMAIL_SEQUENCES, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    const isFirstLoading = networkStatus === 1;

    return {
        stages: data && data.lead && data.lead.stages,
        isLoading: loading,
        isFirstLoading: isFirstLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
